import logo from './logo.svg';
import './App.css';
import * as labels from './components/localized/labels.js'
import UserContext from './components/User_Context.js';
import Site_Routing from './components/Site_Routing.js';
import * as api from "./api/apiConnector.js";

function App() {
  const currentUser = () => {
    let user = localStorage.getItem("user");
    if (user) user = JSON.parse(user);


    return user;
  }

  const doLogout = async (params) => {


    localStorage.removeItem("user");

    return;
  }

  const doLogon = async (params) => {
    localStorage.removeItem("user");

    const { userName, password } = params;

    //call the API
    try {
      var result = await api.sendMessage("Authenticate", {
        body: {
          userName: userName,
          password: password
        }
      });

      if (result?.success && result.user) {
        result.user.token = result.token;
        localStorage.setItem("user", JSON.stringify(result.user));
      }

      return result;
    }
    catch (err) {
      console.log(err);
    }

  }


  const doGoogleLogon = async (params) => {
    localStorage.removeItem("user");

    const { credential } = params;


    try {
      var result = await api.sendMessage("security/googleLogin", {
        body: {
          credential: credential,
          // loginId: loginId
        }

      });

      if (result?.success && result.user) {
        result.user.token = result.token;
        localStorage.setItem("user", JSON.stringify(result.user));
      }

      return result;
    }
    catch (err) {
      console.log(err);
    }


  }

  const createOAuthUrl = async (params) => {
    try {
      var result = await api.sendMessage("security/createOAuthUrl",{
        body:{
        }
      });

      return result;
    }
    catch (err) {
      console.log(err);
    }


}



return (
  <UserContext.Provider value={{ doLogon, doGoogleLogon, doLogout, currentUser, createOAuthUrl }}>
    <Site_Routing>
      <div className="App">

      </div>
    </Site_Routing>
  </UserContext.Provider>
);
}

export default App;
